// This file is generated by scripts/generate-build-info.js
// Do not edit manually.

export const buildId = "dpl_44CpSF1wGh79Mjnf3TqXDBAbYgAd" as const;
export const builtAt = "2026-11-05T02:31:05.814Z" as const;
export const vercelEnv: string | null = "preview";
export const gitCommitSha: string | null = "00856e5a621d8cb5dc0bab4510a72e8d6fa2106d";
export const deploymentId: string | null = "dpl_44CpSF1wGh79Mjnf3TqXDBAbYgAd";
